"use strict";
/**
 * @carbowaste/api-client
 *
 * Shared API client library for CARBOwaste applications.
 * Provides access to BDO, CarboWaste, and Dictionary APIs.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDO_BASE_URL = exports.API_RETRY_CONFIG = exports.CARBOWASTE_WEBPAGE_URL = exports.createCarboWasteEndpoints = exports.BdoEndpoints = exports.DictionaryApiClient = exports.CarboWasteApiClient = exports.BdoApiClient = void 0;
// API Clients
var BdoApiClient_1 = require("./bdo/BdoApiClient");
Object.defineProperty(exports, "BdoApiClient", { enumerable: true, get: function () { return BdoApiClient_1.BdoApiClient; } });
var CarboWasteApiClient_1 = require("./carbowaste/CarboWasteApiClient");
Object.defineProperty(exports, "CarboWasteApiClient", { enumerable: true, get: function () { return CarboWasteApiClient_1.CarboWasteApiClient; } });
var DictionaryApiClient_1 = require("./dictionary/DictionaryApiClient");
Object.defineProperty(exports, "DictionaryApiClient", { enumerable: true, get: function () { return DictionaryApiClient_1.DictionaryApiClient; } });
// Endpoints
var endpoints_1 = require("./config/endpoints");
Object.defineProperty(exports, "BdoEndpoints", { enumerable: true, get: function () { return endpoints_1.BdoEndpoints; } });
Object.defineProperty(exports, "createCarboWasteEndpoints", { enumerable: true, get: function () { return endpoints_1.createCarboWasteEndpoints; } });
Object.defineProperty(exports, "CARBOWASTE_WEBPAGE_URL", { enumerable: true, get: function () { return endpoints_1.CARBOWASTE_WEBPAGE_URL; } });
Object.defineProperty(exports, "API_RETRY_CONFIG", { enumerable: true, get: function () { return endpoints_1.API_RETRY_CONFIG; } });
Object.defineProperty(exports, "BDO_BASE_URL", { enumerable: true, get: function () { return endpoints_1.BDO_BASE_URL; } });
//# sourceMappingURL=index.js.map